"use strict";

import React from "react";
import _ from "lodash";
import Modal from "../base/Modal";
import DomainActions from "../../actions/DomainActions";
import DomainManagementStore, {
  VIEW_MANAGE,
  VIEW_SELECT,
} from "../../stores/DomainManagementStore";
import SelectDomainView from "./SelectDomainView.jsx";
import DomainManageView from "./DomainManageView.jsx";

class DomainManagerModal extends React.Component {
  state = DomainManagementStore.getInitialState();

  componentDidMount() {
    this.unsubscribeStore = DomainManagementStore.listen(this._onStoreChange);
  }

  componentWillUnmount() {
    if (this.unsubscribeStore) {
      _.attempt(this.unsubscribeStore);
    }
  }

  _onStoreChange = (state) => {
    this.setState(state);
  };

  _selectDomain = (domain) => {
    DomainActions.selectDomain({ domain: domain });
  };

  _addSubdomain = (data) => {
    DomainActions.addSubdomain(data);
  };

  _updateView = (view, data) => {
    DomainActions.updateView(view, data);
  };

  _backToSelectView = () => {
    DomainActions.selectDomain({ domain: null });
  };

  render() {
    const viewName = this.state.view;
    const viewState = this.state.views[viewName];
    var view = null;

    let modalProps = _.pick(this.props, Modal.BASIC_PROPS);

    switch (viewName) {
      case VIEW_SELECT:
        view = (
          <SelectDomainView
            {...viewState}
            name={viewName}
            selectDomain={this._selectDomain}
            addSubdomain={this._addSubdomain}
            updateView={this._updateView}
          />
        );
        break;
      case VIEW_MANAGE:
        view = (
          <DomainManageView
            {...viewState}
            name={viewName}
            domain={this.state.selectedDomain}
            updateView={this._updateView}
            onCancel={this._backToSelectView}
          />
        );
        break;
    }

    return (
      <Modal {...modalProps}>
        <Modal.Dialog>
          <Modal.Dialog.Header closeButton>
            <Modal.Dialog.Title>Manage Domains</Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body style={{ padding: 0, minHeight: 530 }}>{view}</Modal.Dialog.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default DomainManagerModal;
